<template>
  <div class="flex flex-row flex-nowrap items-center gap-6 font-normal">
    <span>{{ props.label }}</span>
    <span class="flex-1 bg-[#CEEDED] overflow-hidden h-[4px] relative">
      <span
        class="absolute h-full bg-primary"
        :style="{ width: `${props.progress}%` }"
      >
      </span>
    </span>
    <span class="w-[4ch] text-right">{{ props.progress }}%</span>
  </div>
</template>

<script setup>
const props = defineProps({
  label: {
    type: String,
  },
  progress: {
    type: Number,
  },
});
</script>
